import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { transactionLaneDataHandle } from '../state/actions';
import { Loading } from '../../Common/components/Loading';
import { PlusOutlined, CloseCircleOutlined, InboxOutlined } from '@ant-design/icons';
import { Button, Form, Image, Input, List, message, Modal, Popconfirm, Spin, Tabs, Tooltip, Typography } from 'antd';
import Dragger from 'antd/lib/upload/Dragger';
import imageCompression from 'browser-image-compression';
import axios from 'axios';
import imagePlaceholder from "../../Assets/imagePlaceholder.webp";
import "../style/index.css";
import { changeExtensiontoLowerCase, formatAddress, getPreSignedUrls, uploadFileToS3 } from '../../Common/utils/extraFunctions';
const { TabPane } = Tabs;

const CompanyTitle = ({ setCompanyModalStep, companyModalStep}) => {
  const [addCompany, setAddCompany] = useState(false);
  const [bufferData, setBufferData] = useState();
   const [fileData, setFileData] = useState(null);
    const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { Text } = Typography;
  const { getTitleCompanyData, getTitleCompanyLoading, getTitleCompanyError, allTitleCompanyData }=useSelector(
    (state) => state.rtdTransactionLane
  );
  const [activeTab, setActiveTab] = useState("1");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  let dataPerPage = 50;

  let unmounted = {
    value: false
  };
  let source = axios.CancelToken.source();
  useEffect(()=>{
    dispatch(transactionLaneDataHandle.getTitleCompany({type: "COMPANY", unmounted, source}));
    return () => {
      unmounted.value = true;
      source.cancel("Cancelling in cleanup");
    }
  }, [])

  useEffect(() => {
    if (activeTab === "2") {
      setIsLoading(true);
      dispatch(transactionLaneDataHandle.getTitleCompany({ type: "COMPANY", unmounted, source, getAll: true, page, setHasMore, setIsLoading, dataPerPage, 
        search: debouncedSearch,
       }))
    }

    return () => {
      unmounted.value = true;
      source.cancel("Cancelling in cleanup");
    };
  }, [activeTab, page, debouncedSearch]);

  // Reset page when switching tabs
  useEffect(() => {
    if (activeTab === "2") {
      setPage(1);
    }
  }, [activeTab]);

  // Handle scroll event (Infinite scrolling)
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollTop + clientHeight >= scrollHeight - 50 && hasMore && !isLoading) {
      setPage(prev => prev + 1);
    }
    setTimeout(() => {
    }, 3000);
  }

  // Debounce search input
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchText);
      setPage(1);
    }, 500);
  
    return () => {
      clearTimeout(handler);
    };
  }, [searchText]);
  

  const handleSelectedValues=(value)=>{
    setCompanyModalStep({
      ...companyModalStep,
      titleCompany: value,
      inBuilt: true,
      titleOffice: "",
      titleCloser: "",
      salesRep: ""
    })

    // if selected Normalized Title Company then close the modal
    if (value?.addedUniqueKey) {
      setAddCompany(!addCompany)
    }
  }

  const reset = (event)=>{
    event.stopPropagation();
    setCompanyModalStep({
      ...companyModalStep,
      titleCompany: "",
      inBuilt: true,
      titleOffice: "",
      titleCloser: "",
      salesRep: ""
    })
  }

  const handleAdd = () => {
    setAddCompany(!addCompany)
    setBufferData(null);
    setActiveTab("1");
    setSearchText(" ")
  }

  async function compressImage(file) {
    const maxSizeMB = 3; 
    const maxSizeBytes = maxSizeMB * 1024 * 1024;
    if (file.size <= maxSizeBytes) {
      return file;
    }
  
    const initialQuality = 0.7;
    let currentQuality = initialQuality;
  
    
    while (true) {
      try {
        const compressedFile = await imageCompression(file, { quality: currentQuality });
        if (compressedFile.size <= maxSizeBytes || currentQuality <= 0.1) {
          return compressedFile;
        }
        currentQuality -= 0.1;
      } catch (error) {
        throw error;
      }
    }
  }

  function bytesToSize(bytes) {
    let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  }

  let handleCustome = async (data) => {
    const rawFile = data?.file?.originFileObj || data?.file;
    setFileData(rawFile)
    const image = await compressImage(data.file)
    const reader = new FileReader();
    reader.readAsDataURL(data.file);
    reader.onload = () => {
      const newFile = {
        name: data.file.name,
        size: bytesToSize(image.size),
        file: reader.result,
        origin: "notBase64",
      };
      setBufferData(newFile);
    };
    reader.onerror = (error) => {
      return error;
    };
  };
  const uploadImagesToS3 = async (imageBuffers) => {
   
    try {
      setLoading(true); // 🔥 start loading

  
      if (!imageBuffers || (Array.isArray(imageBuffers) && imageBuffers.length === 0)) {
        message.error("No files to upload.");
        return null;
      }
  
      const fileName = changeExtensiontoLowerCase(imageBuffers.name);
      const fileList = [fileName];
      const preSignedUrls = await getPreSignedUrls(fileList,"TRANSACTION");
  
      if (!preSignedUrls || preSignedUrls.length === 0) {
        message.error("No valid files to upload.");
        return null;
      }
  
      const uploadedFilesInfo = [];
  
      
  
      const { url: uploadUrl } = preSignedUrls.find(
        (item) => item?.fileName === fileData?.name
      ) || {};
  
  
      if (!uploadUrl) {
        message.error(`URL not found for file: ${fileData?.name}`);
      } else {
        const finalFileLink = await uploadFileToS3(fileData, uploadUrl);
        uploadedFilesInfo.push(finalFileLink);
      }
  
      return uploadedFilesInfo;
    } catch (error) {
      console.error("Error uploading images:", error);
      message.error("Upload failed. Please try again.");
      return null;
    } finally {
      setLoading(false); // 🔥 stop loading (even if error happens)
    }
  };
  
  const onFinish = async (values) => {
    
    let uploadedFilesInfo=[]
    if(bufferData){
     uploadedFilesInfo = await uploadImagesToS3(bufferData);
    }
    setCompanyModalStep({
      ...companyModalStep,
      inBuilt: false,
      titleCompany: {
        name: values?.companyName,
        officeLogo: uploadedFilesInfo?.[0]|| ""
      },
      titleOffice: "",
      titleCloser: "",
      salesRep: ""
    })
    setAddCompany(!addCompany)
  }
 
  return (
    <div style={{width:"100%",margin:"auto",textAlign:"center"}}>
      {
        getTitleCompanyLoading ? (
          <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
            <Loading />
          </div>
        ) : 
        (
            getTitleCompanyError ? "" :
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gridGap: "10px",
                }}>
                    {getTitleCompanyData?.map((element, index) => {
                        return (
                        <div
                            style={{
                            height: "130px",
                            cursor :"pointer", 
                            padding:"10px",
                            borderRadius:"8px",
                            background: (companyModalStep?.titleCompany?._id === element?._id)  ? "rgb(132, 187, 238)" : "white"
                            }}
                            onClick={() => handleSelectedValues(element)}
                        >
                            {
                            (companyModalStep?.titleCompany?._id === element?._id) && <div style={{position: "absolute", marginTop: "-4px", marginLeft: "170px"}}>
                                <CloseCircleOutlined
                                style={{ fontSize: "20px",  }}
                                onClick={reset}
                                />
                            </div>
                            }
                            <img
                            src={element.officeLogo}
                            style={{
                                minWidth: "100px",
                                minHeight: "100px",
                                objectFit: "contain",
                                maxWidth: "100%",
                                maxHeight:"110px"
                            }}
                            alt=""
                            />
                        </div>
                        );
                    })}
                    {
                      (companyModalStep?.inBuilt && !companyModalStep?.titleCompany?.addedUniqueKey) ? <div
                        style={{
                            height: "120px",
                            padding:"20px",
                            borderRadius:"8px"
                        }}
                        >
                        <Tooltip title="Add Company">
                            <PlusOutlined style={{cursor :"pointer", fontSize: "30px", padding: "35px", border: "1px dashed grey"}} onClick={handleAdd}/>
                        </Tooltip>
                        </div> :
                        <div
                        style={{
                            height: "120px",
                            cursor :"pointer", 
                            borderRadius:"8px",
                            background: "rgb(132, 187, 238)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                        >
                        <div style={{position: "absolute", marginTop: "-80px", marginRight: "-170px"}}>
                            <CloseCircleOutlined
                            style={{ fontSize: "20px",  }}
                            onClick={reset}
                            />
                        </div>
                        {
                            loading?<Spin/>:companyModalStep?.titleCompany?.officeLogo ? <img
                            src={companyModalStep?.titleCompany?.officeLogo||bufferData.file}
                            style={{
                                minWidth: "100px",
                                minHeight: "100px",
                                padding:"20px",
                                objectFit: "contain",
                                maxWidth: "100%",
                                maxHeight:"110px"
                            }}
                            alt={companyModalStep?.titleCompany?.name}
                            /> : <Text style={{ fontSize: "20px" }}>{companyModalStep?.titleCompany?.name}</Text>
                        }
                        </div>
                    }
                </div>
        )
      }
      {
        addCompany && <Modal
          // title={<div>Add Title Company</div>}
          open={true}
          onCancel={handleAdd}
          style={{ marginTop: "-50px" }}
          footer={false}
          width={600}
        >
          <Tabs defaultActiveKey="1"
          activeKey={activeTab}
          onChange={(key) => {
            setActiveTab(key);
          }}
          >
          <TabPane tab="Create New" key="1">
          {loading?<Loading/>:<Form
            layout="vertical"
            onFinish={onFinish}
          >
            <Form.Item
              label={<div style={{fontSize: "15px"}}>Enter Company Name</div>}
              name="companyName"
              rules={[{ required: true, message: "Please Enter Company Name!" }]}
            >
              <Input placeholder="Enter Company Name" allowClear autoFocus/>
            </Form.Item>
            <Form.Item
              label={<div style={{fontSize: "15px"}}>Add Company Image</div>}
            >
              {bufferData ? (
                <div
                  style={{
                    display: "flex",
                    maxWidth: "100%",
                    overflow: "auto",
                    minHeight: "100px",
                    boxShadow:
                      "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                  }}
                >
                  <div style={{ margin: "10px" }}>
                    <Image
                      width={100}
                      src={bufferData.file}
                      preview={{
                        visible: false,
                        mask: (
                          <div
                            style={{
                              cursor: "pointer",
                              position: "absolute",
                              zIndex: 21,
                              top: "0px",
                              right: "0px",
                            }}
                          >
                            <div
                              onClick={(event) => {
                                event.stopPropagation();
                              }}
                            >
                              <Popconfirm
                                title="Are you sure you want to delete this image?"
                                onConfirm={() => {
                                  setBufferData(null);
                                }}
                                okText="Yes"
                                cancelText="No"
                              >
                                <CloseCircleOutlined
                                  style={{ fontSize: "30px" }}
                                />
                              </Popconfirm>
                            </div>
                          </div>
                        ),
                      }}
                    />
                  </div>
                </div>
              ) : (
                <Dragger
                  accept="image/*"
                  showUploadList={false}
                  customRequest={handleCustome}
                >
                  <div style={{ height: "100px" }}>
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined
                        style={{ position: "relative", top: "-25px" }}
                      />
                    </p>
                    <p
                      className="ant-upload-text"
                      style={{ position: "relative", top: "-55px" }}
                    >
                      Click or drag file to this area to upload
                    </p>
                    <p
                      className="ant-upload-hint"
                      style={{ position: "relative", top: "-55px" }}
                    >
                      Strictly prohibit from uploading company data or other banned files
                    </p>
                  </div>
                </Dragger>
              )}
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                style={{
                  width: "100%"
                }}
                htmlType="submit"
              >
                Add
              </Button>
            </Form.Item>
            </Form>}
          </TabPane>
            <TabPane tab="Search Existing" key="2">
              <Input
                placeholder="Search Title Company"
                onChange={(e) => setSearchText(e.target.value)}
                allowClear
                enterButton="Search"
                style={{ marginBottom: "16px" }}
                size="middle"
              />
              <div
                style={{
                  maxHeight: "55vh",
                  overflowY: "auto",
                  paddingRight: "8px",
                }}
              >
                {getTitleCompanyLoading && page === 1 ? (
                  <div
                    style={{
                      minHeight: "30vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Spin size="large" />
                  </div>
                ) : (
                  <div
                    style={{
                      height: "50vh",
                      overflowY: "auto",
                      paddingRight: "8px",
                      border: "1px solid #f0f0f0",
                      borderRadius: "8px",
                    }}
                    onScroll={handleScroll}
                  >
                    <List
                      dataSource={allTitleCompanyData?.filter((item) => item?.addedUniqueKey) || []}
                      locale={{ emptyText: "No Title Companies Found" }}
                      renderItem={(item) => (
                        <List.Item className='CompanyListItem'
                          key={item._id}
                          style={{
                            padding: "10px",
                            background: "#fafafa",
                            marginBottom: "10px",
                            borderRadius: "8px",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            boxShadow: "rgba(99, 99, 99, 0.05) 0px 2px 8px 0px",
                          }}
                          onClick={() => handleSelectedValues(item)}
                        >
                          <List.Item.Meta
                            avatar={
                              <img
                                src={item.officeLogo || imagePlaceholder}
                                alt="logo"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "contain",
                                  borderRadius: "4px",
                                  background: "#fff",
                                  border: "1px solid #eee",
                                }}
                              />
                            }
                            title={<span style={{ fontWeight: 600 }}>{item.name || ''}</span>}
                            description={<span style={{fontSize: 'small'}}>{formatAddress(item?.address)}</span>}
                          />
                        </List.Item>
                      )}
                    />
                    {(hasMore && page > 1) && (
                      <div style={{ textAlign: "center", padding: "16px" }}>
                        <Spin />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </TabPane>
          </Tabs>
        </Modal>
      }
    </div>
  )
}
export {CompanyTitle}
